import { HttpClient } from "@/api/services/http";
import { Folder } from "@/types/folder";

const normalizeDate = (value?: string | null) => {
    if (!value) {
        return new Date().toISOString();
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return new Date().toISOString();
    }
    return date.toISOString();
};

const normalizeFolderRecord = (raw: any): Folder => {
    if (!raw || typeof raw !== 'object') {
        throw new Error('Invalid folder record received from folder service');
    }

    const rawCount = raw.item_count ?? raw.itemCount;
    const itemCount = Number(rawCount);

    return {
        id: raw.id,
        name: raw.name ?? 'Untitled Folder',
        parentId: raw.parent_id ?? raw.parentId ?? null,
        createdAt: normalizeDate(raw.created_at ?? raw.createdAt),
        updatedAt: raw.updated_at ? normalizeDate(raw.updated_at) : undefined,
        description: raw.description ?? undefined,
        icon: raw.icon ?? undefined,
        color: raw.color ?? undefined,
        itemCount: Number.isNaN(itemCount) ? 0 : itemCount
    };
};

export const folderService = {
    fetchFolders: async () => {
        const response = await HttpClient.apiClient.get("/content-folder/list");
        const payload = response.data;

        const foldersArray = Array.isArray(payload?.data)
            ? payload.data
            : Array.isArray(payload)
                ? payload
                : [];

        return foldersArray.map(normalizeFolderRecord);
    },

    createFolder: async (folder: Folder) => {
        const response = await HttpClient.apiClient.post("/content-folder", folder);
        return response.data;
    }
}
